import {
	getValidationOutcome,
	getValidationOutcomeBorderColor,
	getValidationOutcomeColor,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/BankAccounts/components/BankAccounts.utils.ts';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import {
	BankAccountValidationOutcomeFilter,
	MipInvestorBankAccountValidationRes,
} from '@dealstack/shared/lib/generated';

interface OutcomePresentation {
	labelKey: string;
	defaultValue: string;
	iconVariant: PredefinedIcons;
}

/**
 * Badge copy for the detail card. The list's VALIDATION_OUTCOME_LABEL_KEYS names the same
 * outcomes, but as filter chips — here the badge has to say what the provider lookup did.
 * NOT_CHECKED is null on purpose: nothing has looked at the account, so there is no finding
 * to report and the section carries no badge.
 */
const OUTCOME_PRESENTATION: Record<BankAccountValidationOutcomeFilter, OutcomePresentation | null> =
	{
		[BankAccountValidationOutcomeFilter.COMPLIANT]: {
			labelKey: 'bank_accounts.details.validation.validated',
			defaultValue: 'Auto-validated',
			iconVariant: 'checkmark-circle',
		},
		[BankAccountValidationOutcomeFilter.FAILED]: {
			labelKey: 'bank_accounts.details.validation.failed',
			defaultValue: 'Not validated',
			iconVariant: 'exclamation-circle',
		},
		[BankAccountValidationOutcomeFilter.INCONCLUSIVE]: {
			labelKey: 'bank_accounts.details.validation.inconclusive',
			defaultValue: 'Validation inconclusive',
			iconVariant: 'exclamation-circle',
		},
		[BankAccountValidationOutcomeFilter.NOT_CHECKED]: null,
	};

export interface ValidationBadgeDetails {
	outcome: BankAccountValidationOutcomeFilter;
	color: string;
	borderColor: string;
	presentation: OutcomePresentation | null;
}

export const getValidationBadgeDetails = (
	validation: MipInvestorBankAccountValidationRes | null
): ValidationBadgeDetails => {
	const outcome = getValidationOutcome({ validation });

	return {
		outcome,
		color: getValidationOutcomeColor(outcome),
		borderColor: getValidationOutcomeBorderColor(outcome),
		presentation: OUTCOME_PRESENTATION[outcome],
	};
};
